var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 95,
    viewBox: "0 0 23 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4419 39.9275L6.79302 52.429H3.42326L0.641861 39.9275H4.17209L5.88372 48.0783L10.8581 39.9275H14.4419Z",
    fill: "url(#paint0_linear_0_184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6605 59.258C10.7512 58.9826 10.0023 58.7073 9.46744 58.2667L10.8046 55.6232C11.393 56.0087 12.0884 56.3391 12.7837 56.5594C13.4791 56.7797 14.1744 56.8899 14.8698 56.8899C15.5116 56.8899 16.0465 56.7797 16.4209 56.6145C16.7953 56.3942 16.9558 56.1739 16.9558 55.7884C16.9558 55.513 16.7953 55.2377 16.4744 55.0725C16.1535 54.9072 15.6186 54.742 14.9233 54.5217C14.1209 54.3015 13.4791 54.0812 12.9442 53.8609C12.4093 53.6406 11.9814 53.3101 11.607 52.8696C11.2326 52.429 11.0186 51.8232 11.0186 51.1073C11.0186 50.2261 11.2326 49.4551 11.7139 48.7391C12.1953 48.0783 12.8907 47.5275 13.7465 47.1971C14.6023 46.8116 15.6721 46.6464 16.8488 46.6464C17.7046 46.6464 18.507 46.7565 19.2558 46.9217C20.0046 47.087 20.6465 47.3623 21.1814 47.6928L19.9512 50.3362C19.4698 50.0058 18.9349 49.7855 18.4 49.6203C17.8116 49.4551 17.2233 49.4 16.6349 49.4C15.9395 49.4 15.4046 49.5101 15.0302 49.7304C14.6558 49.9507 14.4419 50.2261 14.4419 50.6116C14.4419 50.942 14.6023 51.1623 14.9233 51.3275C15.2442 51.4928 15.7791 51.658 16.4744 51.8783C17.2767 52.0986 17.9186 52.2638 18.4535 52.4841C18.9884 52.7044 19.4163 53.0348 19.7907 53.4754C20.1651 53.9159 20.3256 54.5217 20.3256 55.2377C20.3256 56.1188 20.1116 56.8899 19.6302 57.5507C19.1488 58.2116 18.4535 58.7623 17.5977 59.0928C16.6884 59.4783 15.6721 59.6435 14.4953 59.6435C13.5326 59.6435 12.5698 59.5333 11.6605 59.258Z",
    fill: "url(#paint1_linear_0_184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 95C1.49767 86.9594 3.2093 79.029 4.97442 71.0435C5.83023 67.0783 6.79302 63.113 7.70233 59.1478L10.5372 47.2522L13.4791 35.4116C14.4953 31.4464 15.4581 27.5362 16.5279 23.571C17.5442 19.6058 18.614 15.6957 19.6837 11.7855L23 0C22.7326 2.03768 22.3047 4.02029 21.9302 6.05797C21.5558 8.04058 21.1279 10.0783 20.7535 12.0609L19.5233 18.0638C19.0954 20.0464 18.6674 22.029 18.2395 24.0116C17.8116 25.9942 17.3837 27.9768 16.9023 29.9594L15.5116 35.9072L12.6767 47.8029L9.73488 59.6435C8.71861 63.6087 7.70233 67.5188 6.63256 71.4841C4.54651 79.3594 2.40698 87.1797 0 95Z",
    fill: "url(#paint2_linear_0_184)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_184",
    x1: -6.89075,
    y1: 41.2107,
    x2: 10.9956,
    y2: 46.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6274,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9257,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_184",
    x1: 11.4931,
    y1: 51.9675,
    x2: 26.0886,
    y2: 55.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6274,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9257,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_184",
    x1: 11.5041,
    y1: 3.30033,
    x2: 11.5041,
    y2: 93.9066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6274,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9257,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D7D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsIcon);
export default __webpack_public_path__ + "static/media/vsIcon.37b36fd42fef36a1f4c0a498ad87b37a.svg";
export { ForwardRef as ReactComponent };